import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37a4dfeb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37a4dfeb&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a4dfeb')) {
      api.createRecord('37a4dfeb', component.options)
    } else {
      api.reload('37a4dfeb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37a4dfeb", function () {
      api.rerender('37a4dfeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/vehicleManagement/index.vue"
export default component.exports